import { GoogleEvent } from '@app/googlecalendar'
import { adjustSeconds, daysDiff, formatDateTime, formatTime } from '@app/utils'
import { getUserPreferences } from 'src/services/getUserPreferences'

export function getDateFromUnion(union: any) {
	let res = union.dateTime
	if (!res) res = union.date + 'T00:00:00'
	return new Date(res)
}

export function parseCalendarEvent(
	event?: GoogleEvent,
	use24HourTime: boolean = false
): { dateStr: string; startTime: string; tooltip: string } {
	if (!event) return { dateStr: '', startTime: '', tooltip: '' }
	const sDate = getDateFromUnion(event.start)
	const eDate = getDateFromUnion(event.end)
	const { prefer24HourTime } = getUserPreferences()

	let startTime = event.start.dateTime ? formatTime(event.start.dateTime, prefer24HourTime) + ' ' : ''
	let dateStr = formatDateTime(sDate, 'wdl, mmmm dd, yyyy')
	if (startTime) dateStr = dateStr + ', ' + startTime
	const isMultiDay = daysDiff(sDate, eDate) > 1
	if (isMultiDay) {
		const effectiveEndDate = adjustSeconds(eDate, -1)

		let tmpStr = formatDateTime(effectiveEndDate, 'wdl, mmmm dd, yyyy')
		let time = event.end.dateTime ? formatTime(event.end.dateTime, prefer24HourTime) + ' ' : ''
		if (time) tmpStr = tmpStr + ', ' + time
		dateStr = dateStr + ' - ' + tmpStr
	}
	let tooltip = event.summary
	tooltip += '\n' + dateStr
	if (event.description) tooltip += '\n' + event.description

	return { dateStr, startTime, tooltip }
}
